import script from "./orderHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./orderHistory.vue?vue&type=script&setup=true&lang=js"

import "./orderHistory.vue?vue&type=style&index=0&id=aec4e7b6&lang=less&scoped=true"

import exportComponent from "/Users/zhan/Documents/ui-app-web-new/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aec4e7b6"]])

export default __exports__